import { ExternalTransfer as RefreshExternalTransfer } from "./ExternalTransfer";
import { ExternalTransfer as LegacyExternalTransfer } from "../legacy/ExternalTransfer";
import FiBranding from "../theme/branding";

/**
 * Picks the UI generation for this transfer's FI.
 *
 * `enable_receiving_ui_refresh` arrives on the branding payload (fi_branding).
 * Until it is true the pre-refresh screen renders, so every FI keeps the UI it
 * has today until it is opted in. FiBranding also stamps `data-ui` on <html>,
 * which is what selects the matching scoped stylesheet.
 */
const ExternalTransferSwitch = () => {
  const { branding } = FiBranding();
  return branding.enable_receiving_ui_refresh === true ? (
    <RefreshExternalTransfer branding={branding} />
  ) : (
    <LegacyExternalTransfer branding={branding} />
  );
};

export default ExternalTransferSwitch;
